import React from "react";
import styles from "./EventMainInfo.module.scss";
import { useEventStore } from "../store";
import EventDate from "../ui/EventMainInfo/EventDate";
import EventAction from "../ui/EventMainInfo/EventAction";
import EventAddress from "../ui/EventMainInfo/EventAddress";
import EventOrganizer from "../ui/EventMainInfo/EventOrganizer";

const EventMainInfo = () => {
  const { eventData } = useEventStore();
  return (
    <div className={styles.EventMainInfo}>
      <div className={styles.EventMainInfo_Left}>
        <EventAction />
        <EventDate />
        {eventData?.name && (
          <h1 className={styles.EventMainInfo_Left_Name}>{eventData.name}</h1>
        )}
        <EventAddress />
      </div>
      <div className={styles.EventMainInfo_Right}>
        <EventOrganizer />
      </div>
    </div>
  );
};

export default EventMainInfo;
